// jQuery kommt von Contao (Layout: addJQuery) als globales window.jQuery.
// Der Import wird per resolve.alias (vite.config.js) auf jquery-global.js
// umgebogen, damit jQuery nicht ein zweites Mal mitgebundelt wird.
import $ from 'jquery';

import 'bootstrap-sass';

import '../scss/styles.scss';

$(function() {

	// STICKY BEHAVIOR

	var $body = $("body"),
		windowHeight = $(window).height(),
		isMobile = ($(window).width() <= 992),
		navbarBottom = $("body.navbar-bottom").length > 0,
		scrollOffset = navbarBottom ? (windowHeight - (isMobile ? 60 : 120)) : 120;

	$(window).on("scroll", function () {
		if ($(this).scrollTop() > scrollOffset) {
			$body.addClass("header-sticky");
		} else {
			$body.removeClass("header-sticky");
		}
	});


	// OVERLAY MENU

	$("[data-toggle=collapse]").on("click", function () {
		if (!$("body").hasClass("show-menu")) {
			$("#overlay-menu").css("display", "block");
			setTimeout(function () {
				$("body").addClass("show-menu");
			}, 50);
		} else {
			$("body").removeClass("show-menu");
			setTimeout(function () {
				$("#overlay-menu").css("display", "none");
			}, 500);
		}
	});

	$(".navbar-collapse a").on("click", function () {
		$(".navbar-collapse").removeClass("in");
		$("body").removeClass("show-menu");
	});

});
